<template>
    <div class="app-container">

        <el-dialog :visible.sync="dialogTableVisible" :close-on-click-modal="false" width="65%" :destroy-on-close="true"
            v-if="dialogTableVisible">
            <invite-user-info :curInviteObj="curInviteObj"></invite-user-info>
        </el-dialog>

        <div class="filter-container">
            <div class="filter-item">
                <el-input v-model="listQuery.user_name" placeholder="昵称" class="filter-item" clearable />
            </div>
            <div style="width:100px;flex-shrink: 0;text-align: center;margin: 0 10px;">统计时间段</div>
            <div class="filter-item">
                <el-date-picker v-model="filteDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
                </el-date-picker>
            </div>
            <div class="filter-item">
                <el-select v-model="listQuery.sort_type" placeholder="排行" clearable style="min-width: 210px;">
                    <el-option label="按邀请人数排行" :value="1" />
                    <el-option label="按参与产品体验排行" :value="2" />
                    <el-option label="按参与探店体验排行" :value="3" />
                    <el-option label="按参与线下活动排行" :value="4" />
                    <el-option label="按商户活动人数排行" :value="5" />
                </el-select>
            </div>

            <el-button type="primary" :loading="listLoading" icon="el-icon-search" @click="handleFilter">搜索</el-button>
            <el-button type="warning" :loading="listLoading" icon="el-icon-upload2" @click="exportExcel">导出Excel</el-button>
        </div>

        <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border fit
            highlight-current-row>
            <el-table-column prop="id" align="center" label="ID" min-width="80" />

            <el-table-column prop="name" label="昵称" min-width="80" align="center" />

            <el-table-column prop="subordinate_num" label="邀请人数" min-width="80" align="center" />

            <el-table-column prop="online_num" label="下级产品体验参与统计" min-width="150" align="center" />

            <el-table-column prop="offline_num" label="下级探店体验参与统计" min-width="150" align="center" />

            <el-table-column prop="activity_user_num" label="下级线下活动参与统计" min-width="150" align="center" />

            <el-table-column prop="merchant_activity_num" label="下级参与商户活动" min-width="140" align="center" />

            <el-table-column label="操作" fixed="right" align="center" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button size="mini" @click="openTableDialog(scope.row)">邀新列表</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="listQuery.limit"
                :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>

    </div>
</template>
  
<script>
// 邀新转化
import { subordinate } from "@/api/statistic"
import inviteUserInfo from "./components/inviteUserInfo"
import request from "@/utils/request";
import * as XLSX from "xlsx"

export default {
    data() {
        return {
            list: [{
                name: '1'
            }, {
                name: '2'
            }],
            dialogTableVisible: false,
            curInviteObj: null,
            total: 0,
            listLoading: false,
            listQuery: {
                page: 1,
                limit: 10,
                start_at: null,
                end_at: null,
                user_name: '',
                sort_type: null
            },
            filteDateRange: null,
            viewUserId: '',
            userProfileVisible: false,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            this.listLoading = true;

            const { data } = await subordinate(this.listQuery)
            this.list = data.data;
            this.total = data.total;

            this.listLoading = false;
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList();
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.start_at = null
                this.listQuery.end_at = null
                return
            }
            this.listQuery.start_at = t[0]
            this.listQuery.end_at = `${t[1].split(' ')[0]} 23:59:59`
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        async exportExcel() {
            console.log('exportExcel')
            // 修改excel-邀新转化-附件 9---ok
            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await subordinate({ ...this.listQuery, page: 1, limit: 99999999999 })
                console.log(reqData);

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['用户名', '性别', '年龄', '手机号', '居住地-国家', '居住地-省份', '微信ID', '邮箱',
                     '擅长领域', 
                     '下级产品体验参与统计', '下级探店体验参与统计', '下级线下活动参与统计', '下级商户活动参与统计', '已获得积分', '注册时间'],
                    ...reqData.map((item) => [
                        item.name,
                        item.gender === 1 ? '男性' : item.gender === 2 ? '女性' : '未设置',
                        item.age_group === 1 ? '20岁以下' : item.age_group === 2 ? '21~30岁' : item.age_group === 3 ? '31~40岁' : item.age_group === 4 ? '41~50岁' : item.age_group === 5 ? '51岁以上' : '未设置',
                        item.account,
                        item.country,
                        item.provinces,
                        item.wx_id,
                        item.email,
                        item.evaluation_type_field ? (item.evaluation_type_field.length > 0 ? item.evaluation_type_field.map(item => item.name).join(',') : '') : '',
                        item.online_num,
                        item.offline_num,
                        item.activity_user_num,
                        item.merchant_activity_num,
                        item.integral,
                        item.created_at,
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "邀新转化");
                XLSX.writeFile(wb, `数据统计-邀新转化.xlsx`);

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        },
        viewUserProfile(id) {
            this.viewUserId = id
            this.userProfileVisible = true
        },
        openTableDialog(scope) {
            this.curInviteObj = scope
            this.dialogTableVisible = true
        },
    },
    components: {
        inviteUserInfo
    },
    watch: {
    }
};
</script>
  
<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .filter-item {
        text-align: center;

        .filter-name {
            font-size: 13px;
            margin-right: 6.5px;
            color: #606266;
        }
    }
}
</style>
  